import React from "react";
import "./Description.css";

const Description = ({ text }) => {
  return <p className="description-text">{text}</p>;
};

export default Description;
